import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { CallToActionPayInInstallmentsByCreditCardComponent } from "../../../shared/components/call-to-action-pay-in-installments-by-credit-card/call-to-action-pay-in-installments-by-credit-card.component";
import { CallToActionRegisterComponent } from "../../../shared/components/call-to-action-register/call-to-action-register.component";
import { CategoryCarouselComponent } from "../../../shared/components/category-carousel/category-carousel.component";
import { SliderEventsCallToActionComponent } from "./../../../shared/components/slider-events-call-to-action/slider-events-call-to-action.component";
import { HomeCarouselEventsComponent } from "./home-carousel-events/home-carousel-events.component";
import { HomeMainBannerSliderComponent } from "./home-main-banner-slider/home-main-banner-slider.component";
import { HomeSliderSecondaryComponent } from "./home-slider-secondary/home-slider-secondary.component";

@Component({
    selector: "app-home",
    imports: [
        HomeSliderSecondaryComponent,
        CategoryCarouselComponent,
        AppLayoutComponent,
        SliderEventsCallToActionComponent,
        CallToActionRegisterComponent,
        CallToActionPayInInstallmentsByCreditCardComponent,
        HomeMainBannerSliderComponent,
        HomeCarouselEventsComponent,
        TranslateModule,
    ],
    templateUrl: "./home.component.html",
    styleUrl: "./home.component.scss"
})
export class HomeComponent {
  constructor(private readonly router: Router) {}

  goToEvent() {
    this.router.navigate(["/event/545"]);
  }
}
